import React, { useState } from "react";
import { Download, ExternalLink, Users } from "lucide-react";
import { downloadFile } from "../api";
import { useLang } from "../i18n";
import { EmailReportButton } from "../components/EmailReportButton";

const COUNTRY_PA = "2194";
const base = (p) => `https://oic.icmp.int/index.php?w=myface&s=search&l=es&btn_submit=1&init=1&${p}`;

export default function IcmpPage() {
  const { t } = useLang();
  const [gender, setGender] = useState("");
  const [age, setAge] = useState("");
  const q = [`disapp_country_id=${COUNTRY_PA}`, gender && `gender_id=${gender}`, age && `age_group_id=${age}`].filter(Boolean).join("&");
  const links = [
    { key: "panama", label: t("icmp.link_pa"), url: base(q) },
    { key: "all", label: t("icmp.link_all"), url: base("") },
    { key: "report", label: t("icmp.link_report"), url: "https://oic.icmp.int/index.php?w=myface&s=report&l=es" },
    { key: "site", label: "ICMP — icmp.int", url: "https://www.icmp.int/" },
  ];
  return (
    <div className="space-y-6" data-testid="icmp-page">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900 flex items-center gap-2"><Users className="w-7 h-7 text-[#044CBC]" /> {t("icmp.title")}</h1>
        <p className="text-sm text-slate-500 mt-1 max-w-2xl">{t("icmp.subtitle")}</p>
      </div>
      <div className="ec-card p-6 space-y-4">
        <div className="rounded-lg bg-amber-50 border border-amber-200 text-amber-900 text-xs px-3 py-2" data-testid="icmp-note">{t("icmp.note")}</div>
        <div className="grid sm:grid-cols-2 gap-3">
          <div><label className="ec-label">{t("search.gender")}</label>
            <select className="ec-input" value={gender} onChange={(e) => setGender(e.target.value)} data-testid="icmp-gender">
              <option value="">{t("common.all")}</option><option value="1">Masculino</option><option value="2">Femenino</option>
            </select></div>
          <div><label className="ec-label">{t("search.age")}</label>
            <select className="ec-input" value={age} onChange={(e) => setAge(e.target.value)} data-testid="icmp-age">
              <option value="">{t("common.all")}</option><option value="1">0–17</option><option value="2">18–30</option><option value="3">31–50</option><option value="4">51+</option>
            </select></div>
        </div>
        <div className="flex flex-wrap items-center justify-end gap-2" data-testid="icmp-actions">
          <EmailReportButton pdfPath={`/icmp/pdf?gender=${gender}&age=${age}`} filename="icmp_desaparecidos.pdf" subject="Consulta ICMP — Personas desaparecidas" module="ICMP Desaparecidos" summary={[gender && `Género ${gender}`, age && `Edad grupo ${age}`].filter(Boolean).join(" · ") || "Panamá — todos"} testid="icmp-email" />
          <button type="button" onClick={() => downloadFile(`/icmp/pdf?gender=${gender}&age=${age}`, "icmp_desaparecidos.pdf")} data-testid="icmp-pdf-button" className="flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-[#16335F] text-white text-xs font-bold hover:bg-[#033A8C]">
            <Download className="w-3.5 h-3.5" /> {t("common.download_pdf")}
          </button>
        </div>
        <div className="grid sm:grid-cols-2 gap-2">
          {links.map((l) => (
            <a key={l.key} href={l.url} target="_blank" rel="noopener noreferrer" data-testid={`icmp-link-${l.key}`}
               className="flex items-center justify-between gap-2 rounded-lg border border-slate-300 px-3 py-2.5 text-sm font-semibold text-slate-800 hover:border-[#044CBC] hover:text-[#044CBC] hover:bg-[#EFF4FC]">
              <span className="truncate">{l.label}</span><ExternalLink className="w-3.5 h-3.5 shrink-0" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
